module.exports = __webpack_public_path__ + "static/img/A62.bdb8b0ca.jpg";